import React from "react";
import { Link } from "react-router-dom";
import { PATH_ABOUT } from "../../utils/constants";
import { ArrowRightIcon } from "@heroicons/react/24/outline";

interface TeamMemberPreviewProps {
  src: string;
  name: string;
  brightness?: string;
  className?: string;
}

const TeamMemberPreview: React.FC<TeamMemberPreviewProps> = ({ src, name, brightness = "", className = "" }) => (
  <div className={`group relative max-w-[800px] mx-auto ${className}`}>
    <div className="aspect-[16/9] rounded-2xl overflow-hidden shadow-sm bg-white dark:bg-gray-800">
      <img
        src={process.env.PUBLIC_URL + src}
        alt={name}
        className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 ${brightness}`}
      />
    </div>
  </div>
);

export const TeamPreviewSection = () => {
  return (
    <section className="overflow-hidden" aria-label="Unser Team">
      <div className="mx-auto">
        {/* Text Content */}
        <div className="max-w-3xl">
          <h2 className="text-xl sm:text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">Unser Team</h2>
          <p className="mt-4 text-base leading-relaxed text-gray-500 dark:text-gray-400">
            Erfahrene Ergotherapeutinnen, die sich leidenschaftlich für Ihre ganzheitliche Betreuung einsetzen. Jede
            Therapeutin bringt ihre individuellen Stärken und Fachgebiete ein, wodurch wir eine umfassende Versorgung
            gewährleisten können.
          </p>
          <p className="mt-4 text-base leading-relaxed text-gray-500 dark:text-gray-400">
            Gemeinsam arbeiten wir daran, Sie auf Ihrem Weg zu unterstützen.
          </p>
          <div className="mt-6">
            <Link
              to={PATH_ABOUT}
              className="inline-flex items-center gap-2 rounded-full
                border border-ergo-500/30 dark:border-ergo-400/30
                bg-ergo-50/60 dark:bg-ergo-900/30
                px-5 py-2 text-sm font-medium
                text-ergo-700 dark:text-ergo-300
                hover:bg-ergo-100 dark:hover:bg-ergo-900/50
                hover:border-ergo-500/50 dark:hover:border-ergo-400/50
                transition-all duration-200"
            >
              <span>Mehr über unser Team erfahren</span>
              <ArrowRightIcon className="h-3.5 w-3.5" />
            </Link>
          </div>
        </div>

        {/* Team Image */}
        <div className="mt-10">
          <TeamMemberPreview
            src="/images/uns.jpeg"
            name="Team der Ergotherapie Rottweil - Erfahrene Ergotherapeutinnen für Neurologie und Psychiatrie"
          />
        </div>
      </div>
    </section>
  );
};
